export default "__VITE_ASSET__CqeiksIB__"